class SignupCartComponent extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.errors = false;
    this.variantId = null;
    this.sellingPlanId = null;
    this.nextProductVariant = null;
    this.second_product_or_product_variant = null;
    this.shouldClearCart = this.dataset.clearCart === 'true';
  }

  connectedCallback() {
    this.initializeComponent();

    this.addToCartButton = this.querySelector('form button[type="submit"]');
    this.errorMessage = document.getElementById('existing-customer-message');

    // Listen for customer-exists event
    this.addEventListener('customer-exists', this.handleCustomerExists.bind(this));
  }

  async initializeComponent() {
    this.code = await window.__CGC.signUp.getDiscountCode(true);
    this.product = getQueryParam('product')?.toLowerCase();
    this.bindEvents();
  }

  bindEvents() {
    this.querySelector('form').addEventListener('submit', this.handleSubmit.bind(this));

    // Hide error message when user starts typing a new email
    const emailInput = this.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.addEventListener('input', this.hideErrorMessage.bind(this));
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    const email = this.getEmailFromForm();
    if (!email) {
      this.dispatchError('Email is required');
      return;
    }

    await this.proceedToCheckout(email);
  }

  getEmailFromForm() {
    const emailInput = this.querySelector('input[type="email"]');
    return emailInput ? emailInput.value : '';
  }

  async emailExists(email) {
    try {
      const response = await fetch(`https://api.craftginclub.co.uk/api/recharge/customers/exists`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      return data && data.exists ? data.exists : false;
    } catch (error) {
      console.error('Error checking email existence:', error);
      return false;
    }
  }

  async proceedToCheckout(email) {
    console.time('TIMER move to checkout');
    this.setLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      this.dispatchError('Invalid email address');
      this.setLoading(false);
      return;
    }

    let requiresNewCustomer = true;

    // Find applicable offer
    let offer = null;

    const applicableOffers = offers.filter((offer) =>
      offer.applicable_discounts.some((code) => code === this.code)
    );

    if (applicableOffers.length > 0) {
      // Find the offer applicable to the selected product
      const foundOffer = applicableOffers.find((offer) =>
        offer.handle_associations.some((association) => association === this.product)
      );

      if (foundOffer && foundOffer.price) {
        offer = foundOffer;
      }
    } else {
      const foundOffer = applicableOffers[0];

      if (foundOffer && foundOffer.price) {
        offer = foundOffer;
      }
    }

    // Get the welcome product variant ID and selling plan ID
    if (offer && offer.variant_id && offer.selling_plan_id) {
      this.variantId = offer.variant_id;
      this.sellingPlanId = offer.selling_plan_id;
    }

    // Get the welcome product variant ID and selling plan ID
    if (offer && offer.variant_id && offer.selling_plan_id) {
      this.variantId = offer.variant_id;
      this.sellingPlanId = offer.selling_plan_id;
    }

    if (!offer) {
      // find default offer for selected product
      const defaultProductHandle = this.product || window.__CGC.signUp.defaultProduct;
      offer = defaultOffers[defaultProductHandle];

      // Apply a code if none is present, and we've selected a default offer
      if (offer && !this.code) {
        this.code = offer.default_discount;
      }
    }

    if (offer && offer.next_product_variant) {
      this.nextProductVariant = offer.next_product_variant;
    }

    requiresNewCustomer = false;
    // if (offer && offer.allow_existing_customers) {
    // }

    // Find rejoin offer
    const rejoinOffer = rejoinOffers.find((offer) => offer.applicable_discounts.some((code) => code === this.code));

    if (rejoinOffer) {
      if (rejoinOffer.offer_product_sku_or_product_variant) {
        this.variantId = rejoinOffer.offer_product_sku_or_product_variant.id;
        this.sellingPlanId =
          rejoinOffer.offer_product_sku_or_product_variant.selling_plan_allocations[0].selling_plan_id;
      }

      if (rejoinOffer.next_product_variant) {
        this.nextProductVariant = rejoinOffer.next_product_variant;
      }

      if (rejoinOffer.second_product_or_product_variant) {
        this.second_product_or_product_variant = rejoinOffer.second_product_or_product_variant;
      }

      requiresNewCustomer = false;
      // if (rejoinOffer.allow_existing_customers) {
      // }
    }

    // Gift codes don't require new customers
    if (this.code.toLowerCase().startsWith('gift-')) {
      requiresNewCustomer = false;
    }

    // Check if customer exists (if required)
    if (requiresNewCustomer) {
      console.time('TIMER check customer exists');
      const customerExists = await this.emailExists(email);
      console.timeEnd('TIMER check customer exists');

      if (customerExists) {
        this.dispatchEvent(
          new CustomEvent('customer-exists', {
            detail: { email },
          })
        );
        this.setLoading(false);
        return;
      }
    }

    try {
      const signupConfig = {
        mainProduct: {
          handle: this.product,
          defaultHandle: window.__CGC.signUp.defaultProduct,
          variantId: this.variantId,
          sellingPlanId: this.sellingPlanId,
        },
        addonProduct: {
          variantId: this.second_product_or_product_variant?.id,
        },
        nextProduct: {
          variantId: this.nextProductVariant?.id,
        },
        email,
        discountCode: this.code,
      };

      const subscriptionCart = new SubscriptionCart();
      await subscriptionCart.checkout(signupConfig, this.shouldClearCart);

      console.timeEnd('TIMER move to checkout');
    } catch (error) {
      console.error('Checkout error:', error);
      this.dispatchError('Failed to proceed to checkout');
    } finally {
      this.setLoading(false);
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  setLoading(loading) {
    this.isLoading = loading;

    if (this.isLoading) {
      this.addToCartButton.setAttribute('disabled', 'disabled');
      this.addToCartButton.classList.add('loading');
      this.addToCartButton.querySelector('.loading__spinner').classList.remove('hidden');
    } else {
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.classList.remove('loading');
      this.addToCartButton.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  dispatchError(message) {
    this.errors = true;
    this.dispatchEvent(
      new CustomEvent('error', {
        detail: { message },
      })
    );
  }

  handleCustomerExists(event) {
    const email = event.detail.email;

    // Show the existing customer message
    if (this.errorMessage) {
      this.errorMessage.style.display = 'block';

      // Scroll to the error message
      this.errorMessage.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });

      // Focus on the email input for better UX
      const emailInput = this.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.focus();
        emailInput.select();
      }
    }
  }

  hideErrorMessage() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }
}

// Register the custom element
customElements.define('sign-up', SignupCartComponent);
